import styled from '@emotion/styled';

export const InstructionList = styled.ol({
  textAlign: 'left',
  listStyle: 'decimal',
  paddingLeft: 40,
});
